'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexDirection');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/flex-direction.js
// module id = 374
// module chunks = 168707334958949